import React from 'react';
import Page from '../components/pageScrolling';
/**
 * Application home page component
 * @returns {JSX}
 */
const Page404 = () => {

    return (
        <>  <Page>
          
            <h1>404 not found!</h1>
            <p>

            </p>
            </Page>
        </>
    );
};

export default Page404;